import { GenericActions } from "../../redux/generic-actions";
import { componentsReducer } from "../../redux/root.reducer";

export function GroupReducerFactory(rootProp, initialState) {
    return function GroupReducer(state = initialState, action) {
        state = componentsReducer(rootProp, state, action);
        state = selectionReducer(rootProp, state, action);
        state = resetStateReducer(rootProp, state, action, initialState);
        return state;
    };
}

export function selectionReducer(rootProp, state, action) {
    const stateProp: string = action.stateProp;
    let ids;
    let id;
    let toggleState;
    switch (action.type) {
        case `${rootProp}::${GenericActions.TOGGLE_SELECT}`:
            id = action.payload;
            toggleState = state.getIn([stateProp, "ids", id]);
            return state.setIn([stateProp, "ids", id], !toggleState);

        case `${rootProp}::${GenericActions.SELECT_ALL}`:
            ids = state.getIn([stateProp, "ids"]);
            action.payload.forEach((_id) => {
                ids = ids.set(_id, true);
            });
            state = state.setIn([stateProp, "allSelected"], true);
            return state.setIn([stateProp, "ids"], ids);

        case `${rootProp}::${GenericActions.DESELECT_ALL}`:
            ids = state.getIn([stateProp, "ids"]);
            ids = ids.map((_id) => false);
            state = state.setIn([stateProp, "allSelected"], false);
            return state.setIn([stateProp, "ids"], ids);

        default:
            return state;
    }
}

export function resetStateReducer(rootProp, state, action, initialState) {
    const stateProp: string = action.stateProp;
    switch (action.type) {
        case `${rootProp}::${GenericActions.STATE_RESET}`:
            return state.set(stateProp, initialState.get(stateProp));
        default:
            return state;
    }
}
